function App() {
  return <div className="Genome-banner"></div>;
}

export default App;
